import { Component, Input } from '@angular/core';
import { SpinnerColor } from '../../enums';

import { IonicModule } from '@ionic/angular';
@Component({
  selector: 'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls: ['./spinner.component.scss'],
  imports: [IonicModule],
})
export class SpinnerComponent {
  @Input() color: SpinnerColor = SpinnerColor.default;

  @Input() isLoading: boolean | undefined = false;
}
